import {
    IconChevronLeftRegular,
    IconQuestionRegular,
    NavigationBar,
    Row,
    RowList,
    Text1,
    Text2,
    ThemeVariant,
    skinVars,
} from '@telefonica/mistica';
import './index.scss';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import navigateParams from '../../../../utils/navigation/navigateParams';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import BreadCrumbsWrapper from '../../../../components/BreadcrumbsWrapper';

const FaqsOrders: React.FC = () => {
    const navigate = useNavigate();

    const sendToNative = (url: string, type: string) => {
        if (navigateParams(type, url, {})) window.open(url, '_blank');
    };

    const arrayFaqs = [
        {
            title: t('trackingSIMFaq'),
            url: 'https://o2online.es/ayuda/informacion-sobre-proceso-entrega-envio/',
        },
        {
            title: t('instalationFiberFaq'),
            url: 'https://o2online.es/ayuda/cuanto-tardan-en-instalar-la-fibra-o2/',
        },
        {
            title: t('changeNumberFaq'),
            url: 'https://o2online.es/ayuda/proceso-portabilidad/',
        },
        {
            title: t('habitualErrorsFaq'),
            url: 'https://o2online.es/ayuda/el-proceso-de-portabilidad-a-o2-ha-fallado-y-no-se-por-que/',
        },
        {
            title: t('questionsMoviestarFaq'),
            url: 'https://o2online.es/ayuda/alta-o2-vienes-de-movistar/',
        },
        {
            title: t('transferProcessFaq'),
            url: 'https://o2online.es/ayuda/traslado-fibra-o2/',
        },
        {
            title: t('shipmentDeviceFaq'),
            url: 'https://o2online.es/ayuda/cuando-tarda-el-envio-del-dispositivo-movil/',
        },
    ];
    return (
        <div className='orders-faqs-page'>
            <div
                className='orderDetail-page__header'
                style={{
                    background: skinVars.colors.backgroundBrand,
                }}
            >
                {!(isWebviewAndroid || isWebviewIOS) && (
                    <>
                        <div className='orderDetail-page__header-navigationBar'>
                            <NavigationBar
                                isInverse={true}
                                onBack={() => {
                                    navigate(-1);
                                }}
                                title={t('orderDetail')}
                            />
                        </div>
                        <div className='orderDetail-page__header-return'>
                            <div
                                className='orderDetail-page__header-return-cursor'
                                onClick={() => {
                                    navigate(-1);
                                }}
                            >
                                <div className='orderDetail-page__header-return-cursor-icon'>
                                    <IconChevronLeftRegular color={skinVars.colors.appBarBackground} size={20} />
                                </div>
                                <Text2 medium color={skinVars.colors.appBarBackground}>
                                    {t('returnResponsive')}
                                </Text2>
                            </div>
                        </div>
                    </>
                )}
                <div className='orderDetail-page__header-breadcrumbs'>
                    <ThemeVariant isInverse>
                        <BreadCrumbsWrapper
                            title={t('titleFAQsOrders')}
                            breadcrumbs={[{ title: t('profileOrders'), url: '/profile/orders' }]}
                        />
                    </ThemeVariant>
                </div>
            </div>
            <div className='orders-faqs-page__content'>
                <div className='orders-faqs-page__content-title'>
                    <Text1 regular>{t('subtitleFAQsOrders')}</Text1>
                </div>

                <RowList>
                    {arrayFaqs?.map((item, index) => (
                        <Row
                            key={index}
                            title={item.title}
                            asset={<IconQuestionRegular size={20} color={skinVars.colors.textSecondary} />}
                            onPress={() => {
                                sendToNative(item.url, 'modeExternal');
                            }}
                        ></Row>
                    ))}
                </RowList>
            </div>
        </div>
    );
};

export default FaqsOrders;
